export const getVoiceFlowId = state => state.voiceFlows.voiceFlow.id;
export const getVoiceFlowData = state => state.voiceFlows.voiceFlow;
export const voiceFlowIsFetching = state => state.voiceFlows.loading;